export default __webpack_public_path__ + "static/media/cham.835bc929.png";